if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** Target Group Discount
         *
         * toggling Target Group Discount :
         *      on pageload backend should set the "checked" value of of the "doelgroepkorting" checkbox as well as
         *      the "selected" value on any option element to create the desired initial state.
         */
        ZZ.TargetGroupDiscount = function(checkbox) {
            var base = this;
            base.targetDiscountCheckBox = checkbox;

            base.targetDiscountCheckBoxListItem = base.targetDiscountCheckBox.parent();
            base.dataTriggerTargetGroupDiscountAdded = $(
                "[data-trigger-target-group-discount-added]"
            );
            base.dataTriggerTargetGroupDiscountSelectable = $(
                "[data-trigger-target-group-discount-selectable]"
            );
            base.dataTriggerShowOnSelectionEvent = $(
                "[data-trigger-target-group-discount-show-on-selection]"
            );

            base.prospectBasicInsuranceSelect = $(
                "[data-update-gemak-av-select]"
            );
            base.prospectBasicInsuranceSelectOptionBvGemak =
                "[data-is-bv-gemak]";
            base.prospectBasicInsuranceSelectOptionBvRegular =
                "[data-is-bv-regular]";
            base.prospectBasicInsuranceSelectOptionValueNone =
                "[data-value-none]";

            base.prospectAdditionalInsuranceSelect = $(
                "[data-update-gemak-bv-select]"
            );

            base.assignListeners();
            base.init();
        };

        ZZ.TargetGroupDiscount.prototype = {
            assignListeners: function() {
                var base = this;

                base.prospectBasicInsuranceSelect
                    .find("input")
                    .on("change", function() {
                        base.setGemakOrRegularPolis();
                    });

                base.prospectAdditionalInsuranceSelect.on("change", function() {
                    base.setGemakOrRegularPolis();
                });

                base.dataTriggerTargetGroupDiscountAdded.on(
                    "click",
                    function() {
                        base.setGemakOrRegularPolis();
                    }
                );

                base.dataTriggerTargetGroupDiscountSelectable.on(
                    "click",
                    function() {
                        base.setGemakOrRegularPolis();
                    }
                );

                base.targetDiscountCheckBox.on(
                    "change.TargetGroupDiscount",
                    function() {
                        if (base.targetDiscountCheckBox.is(":checked")) {
                            base.setIncludeDiscountSelectionAndAmountsAndTexts();
                        } else {
                            base.setExcludeDiscountSelectionAndAmountsAndTexts();
                        }
                    }
                );

                base.targetDiscountCheckBox.on(
                    "init.TargetGroupDiscount",
                    function() {
                        base.init();
                    }
                );
            },

            init: function() {
                var base = this;

                base.setGemakOrRegularPolis();
                if (base.targetDiscountCheckBox.is(":checked")) {
                    base.setIncludeDiscountSelectionAndAmountsAndTexts();
                } else {
                    base.setExcludeDiscountSelectionAndAmountsAndTexts();
                }
            },

            setIncludeDiscountSelectionAndAmountsAndTexts: function() {
                var base = this;
                base.setIncludeDiscountAmountsAndTexts();
                base.dataTriggerShowOnSelectionEvent.attr(
                    "data-trigger-target-group-discount-show-on-selection",
                    true
                );
            },

            setIncludeDiscountAmountsAndTexts: function() {
                var base = this;
                base.setDiscountAmountsAndTexts(
                    "data-discount-text",
                    "data-discount-amount"
                );
            },

            setExcludeDiscountSelectionAndAmountsAndTexts: function() {
                var base = this;
                base.setExcludeDiscountAmountsAndTexts();
                base.dataTriggerShowOnSelectionEvent.attr(
                    "data-trigger-target-group-discount-show-on-selection",
                    false
                );
            },

            setExcludeDiscountAmountsAndTexts: function() {
                var base = this;
                base.setDiscountAmountsAndTexts(
                    "data-alt-text",
                    "data-alt-amount"
                );
            },

            setDiscountAmountsAndTexts: function(
                dataAttributeText,
                dataAttributeAmount
            ) {
                $("[data-discount-text]").each(function() {
                    $(this).text($(this).attr(dataAttributeText));
                });
                $("[data-discount-amount]").each(function() {
                    $(this).text($(this).attr(dataAttributeAmount));
                });
            },

            setHideTargetGroupDiscountOnGemakPolis: function() {
                var base = this;
                base.targetDiscountCheckBoxListItem.hide();
            },

            setShowTargetGroupDiscountOnRegularPolis: function() {
                var base = this;
                base.targetDiscountCheckBoxListItem.show();
            },

            isOnlyBvGemakPolisSelectChosen: function() {
                return !$("[data-update-gemak-av-select]")
                    .find(":selected, :checked")
                    .not("[data-is-bv-gemak]").length;
            },

            isOnlyAvGemakPolisSelectChosen: function() {
                return !$("[data-update-gemak-bv-select]")
                    .find(":selected, :checked")
                    .not("[data-is-av-gemak]").length;
            },

            isOnlyGemakOnBvOrAvPolisSelectChosen: function() {
                return !$(
                    "[data-update-gemak-bv-select],[data-update-gemak-av-select]"
                )
                    .find(":selected, :checked")
                    .not("[data-value-none]")
                    .not("[data-is-bv-gemak],[data-is-av-gemak]").length;
            },

            debugLoggerIsGemakPolis: function(model) {
                var base = this;
                if (model.isEnabledDebugLogger) {
                    console.log("<<<<<<<");
                    console.log(
                        "base.isOnlyBvGemakPolisSelectChosen() ",
                        base.isOnlyBvGemakPolisSelectChosen()
                    );
                    console.log(
                        "base.isOnlyAvGemakPolisSelectChosen() ",
                        base.isOnlyAvGemakPolisSelectChosen()
                    );
                    console.log(
                        "base.isOnlyGemakOnBvOrAvPolisSelectChosen() ",
                        base.isOnlyGemakOnBvOrAvPolisSelectChosen()
                    );
                    console.log(">>>>>>>");
                }
            },

            isOnlyGemakPolisAcrossAllProspects: function() {
                var base = this;
                base.debugLoggerIsGemakPolis({ isEnabledDebugLogger: false });
                return base.isOnlyGemakOnBvOrAvPolisSelectChosen();
            },

            setGemakOrRegularPolis: function() {
                var base = this;
                if (base.isOnlyGemakPolisAcrossAllProspects()) {
                    base.setHideTargetGroupDiscountOnGemakPolis();
                } else {
                    base.setShowTargetGroupDiscountOnRegularPolis();
                }
            }
        };
    })(jQuery);
}
